<template>
  <div class="base-form">
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="活动名称:" prop="name">
        <div class="active-name">
          <el-input v-model="ruleForm.name" />
        </div>
      </el-form-item>
      <el-form-item label="发放时间:" prop="distributionType">
        <el-radio-group v-model="ruleForm.distributionType">
          <el-radio :label="1">立即发放</el-radio>
          <el-radio :label="2">
            <div class="open-time">
              <span>定时发放</span>
              <template v-if="ruleForm.distributionType == 1">
                <el-date-picker
                  disabled
                  v-model="ruleForm.sendTime"
                  type="datetime"
                  placeholder="选择日期"
                />
              </template>
              <template v-else>
                <el-form-item prop="sendTime">
                  <el-date-picker
                    v-model="ruleForm.sendTime"
                    type="datetime"
                    placeholder="选择日期"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  />
                </el-form-item>
              </template>
            </div>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发放对象:" prop="distributionScope">
        <el-radio-group v-model="ruleForm.distributionScope">
          <el-radio :label="1">选择客户</el-radio>
          <el-radio :label="2">全部客户</el-radio>
        </el-radio-group>
        <div style="margin: 10px 0;" v-if="ruleForm.distributionScope == 1">
          <el-button size="small" type="primary" @click="openImportDialog">
            <el-icon><Upload /></el-icon> 导入客户
          </el-button>
        </div>
        <div v-if="ruleForm.distributionScope == 1" class="opt-client-list">
          <template v-for="(item, index) in ruleForm.userIds">
            <div class="user-wrap">
              <div class="user-item">
                <div class="avatar">
                  <template v-if="item.userAva != 'default_ava.png'">
                    <img :src="item.userAva" alt="" />
                  </template>
                  <template v-else>
                    <img src="@/assets/img/main/base/default_avatar.png" alt="" />
                  </template>
                </div>
                <div class="uname">
                  <div class="nick">{{ item.userRealname }}</div>
                  <div class="phone">{{ item.userMobile }}</div>
                </div>
              </div>
              <div @click="handleDeleteClick(item, index)" class="delete">
                <el-icon>
                  <Delete />
                </el-icon>
              </div>
            </div>
          </template>
          <div @click="handleAddClientClick" class="add-btn">
            <el-icon>
              <Plus />
            </el-icon>
            添加客户
          </div>
        </div>
      </el-form-item>
      <el-form-item label="添加卡项:" prop="cardList">
        <div class="add-card">
          <!-- <div @click="handleAddCardClick" class="btn">选择卡项</div> -->
          <div>最多支持添加15张卡：已选 有限次卡{{cardTotal.cardType1}}｜无限次卡{{cardTotal.cardType2}}｜储值卡{{cardTotal.cardType3}}｜折扣卡{{cardTotal.cardType4}}</div>
        </div>
        <el-scrollbar height="350px">
          <el-tabs v-model="activeStatus" type="card" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in tabStatusList" :key="index" :label="item.label" :name="item.value">
            </el-tab-pane>
            <div class="cards-list">
              <el-table ref="dataTableRef" :data="dataList" highlight-current-row @selection-change="handleSelectionChange" :row-key="getkey">
                <el-table-column align="center" type="selection" width="55" :reserve-selection="true" />
                <el-table-column label="名称" prop="cardName" width="140" />
                <el-table-column label="类型" prop="kindId" align="center" width="120">
                  <template #default="scope">
                    <div class="card-kind" v-if="scope.row.kindId == 3">
                      <span class="el-tag el-tag--success el-tag--light">有限次卡</span>
                    </div>
                    <div class="card-kind" v-if="scope.row.kindId == 4">
                      <span class="el-tag el-tag--warning el-tag--light">不限次卡</span>
                    </div>
                    <div class="card-kind" v-if="scope.row.kindId == 5">
                      <span class="el-tag el-tag--danger el-tag--light">储值卡</span>
                    </div>
                    <div class="card-kind" v-if="scope.row.kindId == 6">
                      <span class="el-tag el-tag--light">折扣卡</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="售价" prop="salePrice" align="center" width="120">
                  <template #default="scope">
                    <p>{{ '¥'+scope.row.salePrice}}</p>
                  </template>
                </el-table-column>
                <el-table-column label="有效期" prop="timeLimitFlag" align="center" width="180">
                  <template #default="scope">
                    <div v-if="scope.row.timeLimitFlag == 1">永久</div>
                    <div v-if="scope.row.timeLimitFlag == 2">
                      {{ dayjs(scope.row.fixStartTime).format("YYYY年MM月DD日") }}-{{
                        dayjs(scope.row.fixEndTime).format("YYYY年MM月DD日")
                      }}
                    </div>
                    <div v-if="scope.row.timeLimitFlag == 3">
                      购买后{{ scope.row.timeLimitDays }}天内有效
                    </div>
                    <div v-if="scope.row.timeLimitFlag == 4">
                      使用后{{ scope.row.timeLimitDays }}天内有效
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="过期后是否可使用" prop="expireUseFlag" align="center" width="150">
                  <template #default="scope">
                    <template v-if="scope.row.expireUseFlag == 1"> 可使用 </template>
                    <template v-else> 不可使用 </template>
                  </template>
                </el-table-column>
                <el-table-column label="发放数量" prop="total" align="center" width="130">
                  <template #default="scope">
                    <div v-if="cardListSelecd.includes(scope.row.cardId)">
                      <el-input-number :controls="false" v-model="cardCountMap[scope.row.cardId]" :min="0" style="width: 100%;"></el-input-number>
                    </div>
                    <p v-else>-</p>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="margin-top: 10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.page" :page-size="queryInfo.pageSize" :page-sizes="[10, 20, 30]"
                layout="total, sizes, prev, pager, next, jumper" :total="dataCount"></el-pagination>
            </div>
          </el-tabs>
        </el-scrollbar>
      </el-form-item>

      <el-form-item label="归属门店：" prop="dpId">
        <el-select
          v-model="ruleForm.dpId"
          class="m-2"
          placeholder="选择门店"
          size="large"
        >
          <el-option
            v-for="item in shopList"
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="">
        <div class="save-btn">
          <el-button @click="handleSaveClick(ruleFormRef)" type="primary">保存</el-button>
        </div>
      </el-form-item>
    </el-form>

    <clientDialog
      @changeUser="handleChangeUser"
      @changeDialogVisible="clientChangeDialogVisible"
      :dialogVisible="clientDialogVisible"
      :selectedUsers="ruleForm.userIds"
      v-if="clientDialogVisible"
    ></clientDialog>

    <!-- 新增：客户导入弹窗 -->
    <clientImportDialog
      v-model:visible="importDialogVisible"
      @import-success="handleImportSuccess"
    ></clientImportDialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import { rules } from '../../config'
import clientDialog from './cpns/client-dialog/client-dialog.vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { getShopList } from '@/service/main/base'
import {COMPANY_ID} from '@/common/constant'
import PageContent from '@/components/page-content2/src/page-content.vue'
import { getAllCardList } from '@/service/main/card'
import { sendCard } from '@/service/main/goods'
import clientImportDialog from '../../../../coupon/add/cpns/base-form/cpns/client-dialog/client-import-dialog.vue'

export default defineComponent({
  props: {

  },
  components: {
    clientDialog,
    PageContent,
    clientImportDialog
  },
  setup() {
    const router = useRouter()

    const ruleForm = reactive({
      optCardList: [],
      distributionScope: 1,
      distributionType: 1,
      userIds: [],
      cardList: [],
      sendTime: "",
      name: "",
      dpId:""
    })
    
    // 新增：存储卡项发放数量的映射表（解决分页丢失问题）
    const cardCountMap = reactive({})
    
    const tabStatusList = reactive([
    {
      value: 0,
      label: '全部'
    },{
      value: 3,
      label: '有限次卡'
    },{
      value: 4,
      label: '无限次卡'
    },{
      value: 5,
      label: '储值卡'
    },{
      value: 6,
      label: '折扣卡'
    }])
    
    const dataList = ref([])
    const dataCount = ref(0)
    
    // 修正拼写错误：pagesize -> pageSize
    const queryInfo = reactive({
      page: 1,
      pageSize: 10
    })

    // 新增：导入弹窗状态
    const importDialogVisible = ref(false)

    // 1. 打开导入弹窗
    const openImportDialog = () => {
      if (ruleForm.distributionScope === 1) {
        importDialogVisible.value = true
      } else {
        ElMessage.warning('请先选择「选择客户」发放方式')
      }
    }

    // 2. 处理导入成功事件
    const handleImportSuccess = (newUsers) => {
      if (newUsers.length > 0) {
        let userfilter = newUsers.filter(user => !ruleForm.userIds.some(u => u.userId === user.userId))
        ruleForm.userIds = [
          ...ruleForm.userIds,
          ...userfilter
        ];
        ElMessage.success(`成功导入 ${newUsers.length} 位客户`)
      }
    }
    
    const handleSizeChange = size => {
      queryInfo.pageSize = size
      getCardList()
    }
    
    const handleCurrentChange = page => {
      queryInfo.page = page
      getCardList()
    }

    const handleChangeUser = value => {
      ruleForm.userIds = value
    }

    const handleChangeCard = value => {
      ruleForm.cardList = value
    }

    const handleClick = async () => {
      getCardList()
    }

    const activeStatus = ref(0)
    
    // 修改获取卡项列表方法，初始化数量映射
    const getCardList = async () => {
      let params={
        current: queryInfo.page,
        size: queryInfo.pageSize,
        kind: activeStatus.value === 0 ? undefined : activeStatus.value,
        cardStatus: 1
      }
      const res = await getAllCardList(params)
      let list = res.data.list
      
      // 初始化已勾选卡项的数量
      list.forEach(item => {
        if (cardListSelecd.value.includes(item.cardId) && !cardCountMap[item.cardId]) {
          cardCountMap[item.cardId] = 0 // 默认值
        }
      })
      
      dataList.value = list
      dataCount.value = Number(res.data.total)
    }

    const cardTotal = ref({
      cardType1:0,
      cardType2:0,
      cardType3:0,
      cardType4:0,
    })
    
    const cardListSelecd = ref([])
    
    // 修改勾选事件处理，初始化数量映射
    const handleSelectionChange = (value) =>{
      cardListSelecd.value = value.map(item => item.cardId)
      ruleForm.cardList = value
      
      // 初始化勾选卡项的数量
      value.forEach(item => {
        if (!cardCountMap[item.cardId]) {
          cardCountMap[item.cardId] = 0 // 默认值
        }
      })
      
      let cardType1=0;
      let cardType2=0;
      let cardType3=0;
      let cardType4=0;
      
      value.map(item=>{
        if (item.kindId===3) cardType1+=1
        else if (item.kindId===4) cardType2+=1
        else if (item.kindId===5) cardType3+=1
        else if (item.kindId===6) cardType4+=1
      })
      
      cardTotal.value = { cardType1, cardType2, cardType3, cardType4 }
    }
    
    const getkey = (row) => row.cardId

    // 修改保存方法，从cardCountMap获取数量
    const handleSaveClick = async (formEl = undefined) => {
      if (!formEl) return
      await formEl.validate(async (valid, fields) => {
        if (valid) {
          let obj = { ...ruleForm }
          let { userIds, distributionType, sendTime, cardList, distributionScope, dpId, name } = obj

          if (distributionScope === 1 && userIds.length === 0) {
            ElMessage.warning('请选择客户！')
            return
          }

          if (cardList.length === 0) {
            ElMessage.warning('请选择卡项！')
            return
          } else if (cardList.length > 15) {
            ElMessage.warning('卡项最多可选15张！')
            return
          }
          
          // 从cardCountMap获取发放数量
          let cardIds = cardList.map(item => ({
            cardId: item.cardId,
            count: cardCountMap[item.cardId] || 0
          }))
          
          // 验证数量填写
          let isHasNoCount = cardIds.some(item => isNaN(item.count) || item.count <= 0)
          if (isHasNoCount) {
            ElMessage.warning('请填写有效的卡项发放数量！')
            return
          }
          
          let userIdArr = userIds.map(ele => ele.userId)

          let params = {
            name,
            distributionType,
            sendTime: distributionType === 1 ? undefined : sendTime,
            userIds: distributionScope === 2 ? [] : userIdArr,
            itemList: cardIds,
            distributionScope,
            dpId
          }
          
          const res = await sendCard(params)
          if (res.code === 0) {
            router.back()
            ElMessage.success('操作成功!')
          } else {
            ElMessage.error(res.msg || '操作失败')
          }
        } else {
          console.log('error submit!', fields)
        }
      })
    }

    const clientDialogVisible = ref(false)
    const clientChangeDialogVisible = flag => {
      clientDialogVisible.value = flag
    }
    const handleAddClientClick = () => {
      clientDialogVisible.value = true
    }

    const cardDialogVisible = ref(false)
    const cardChangeDialogVisible = flag => {
      cardDialogVisible.value = flag
    }
    const handleAddCardClick = flag => {
      cardDialogVisible.value = flag
    }

    const handleDeleteClick = (item, index) => {
      ruleForm.userIds.splice(index, 1)
    }

    const ruleFormRef = ref()

    const shopList = ref([])
    const initPage = async () => {
      const res = await getShopList(COMPANY_ID)
      let list = res.data.list
      list.unshift({ shopId: 0, shopName: "总部" })
      shopList.value = list
      getCardList()
    }
    
    initPage()

    return {
      shopList,
      ruleFormRef,
      handleDeleteClick,
      handleChangeCard,
      handleAddCardClick,
      cardDialogVisible,
      cardChangeDialogVisible,
      handleAddClientClick,
      clientChangeDialogVisible,
      clientDialogVisible,
      ruleForm,
      rules,
      handleChangeUser,
      handleSaveClick,
      tabStatusList,
      dataList,
      dataCount,
      queryInfo,
      handleCurrentChange,
      getCardList,
      handleClick,
      activeStatus,
      handleSelectionChange,
      cardTotal,
      getkey,
      dayjs,
      cardListSelecd,
      handleSizeChange,
      importDialogVisible,
      openImportDialog,
      handleImportSuccess,
      cardCountMap // 暴露数量映射表到模板
    }
  }
})
</script>

<style scoped lang="less">
&:deep(.el-table) {
  .el-table__header-wrapper {
    .el-table__cell {
      background-color: rgba(239, 239, 239, 1);
      .cell {
        color: rgba(80, 80, 80, 1) !important;
        font-size: 14px !important;
        font-weight: 500 !important;
      }
    }
  }
}
.base-form {
  font-size: 12px;

  .open-time {
    display: flex;
    span {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .active-name {
    &:deep(.el-input) {
      max-width: 240px;
    }
  }

  .user-item {
    display: flex;
    align-items: center;
    line-height: 10px;

    .uname {
      .nick {
        margin-bottom: 4px;
      }

      .phone {
        font-size: 12px;
        color: #999;
      }
    }

    img {
      width: 36px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  .save-btn {
    margin-top: 20px;
  }

  .message-tips {
    line-height: 46px;
    background-color: rgb(248, 248, 248);
    padding: 0 10px;
    color: rgb(129, 127, 127);
    font-size: 12px;
  }

  .add-card {
    display: flex;
    color: rgb(153, 153, 153);

    .btn {
      margin-right: 12px;
      font-size: 14px;
      cursor: pointer;
      color: rgb(133, 88, 250);
    }
  }

  .card-list {
    margin-top: 20px;
    border: 1px solid rgb(247, 248, 250);

    .card-item {
      display: flex;

      & > div {
        flex: 1;
      }

      .use-time {
        flex: 3;
      }
    }

    .list {
      min-height: 60px;

      .empty-card:hover {
        background-color: rgb(246, 244, 255);
      }

      .empty-card {
        line-height: 60px;
        color: rgb(200, 201, 204);
        text-align: center;
      }
    }

    .titles {
      display: flex;
      line-height: 40px;
      background-color: rgb(247, 248, 250);
      padding: 0 10px;

      .use-time {
        flex: 3;
      }

      & > div {
        flex: 1;
      }
    }
  }

  .opt-client-list {
    background-color: rgb(248, 248, 248);
    padding: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    min-height: 88px;

    .user-wrap {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 10px;
    }

    & > div {
      margin-right: 2.5%;
      width: 30%;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 56px;
      color: #817f7f;
      cursor: pointer;
    }

    .add-btn {
      margin-bottom: 10px;
    }
  }

  &:deep(.el-form) {
    max-width: 1400px;
  }
}
</style>